<script setup lang="ts">
import { Toast, useDashToast } from '@dashhudson/dashing-ui/toast';
import { ref, watch } from 'vue';

import {
  APP_UPDATE_NOTIFIED_REVISION_KEY,
  APP_UPDATED_KEY,
  latestRevision,
  updateRecommended,
} from '@/composables/useAppVersion';

const APP_UPDATE_TOAST_GROUP = 'app-update';

const { addToast, removeToastGroup } = useDashToast({
  group: APP_UPDATE_TOAST_GROUP,
  severity: 'info',
  message: 'A New Version of Dash Social is Available',
  CTA: 'Refresh to Update',
  closable: true,
  life: 0,
});

const shown = ref(false);
watch(
  updateRecommended,
  (val) => {
    if (!val || shown.value) return;
    const revision = latestRevision.value;
    if (!revision) return;
    // Show at most once per stale revision: when the user reloads or a new
    // deploy lands, latestRevision changes and this gate reopens.
    if (localStorage.getItem(APP_UPDATE_NOTIFIED_REVISION_KEY) === revision) return;
    localStorage.setItem(APP_UPDATE_NOTIFIED_REVISION_KEY, revision);
    shown.value = true;
    addToast();
  },
  { immediate: true },
);

function onAction(): void {
  sessionStorage.setItem(APP_UPDATED_KEY, '1');
  removeToastGroup(APP_UPDATE_TOAST_GROUP);
  window.location.reload();
}
</script>

<template>
  <Toast :group="APP_UPDATE_TOAST_GROUP" @action="onAction" />
</template>
